<template>
    <CustomDialog
        :value="value"
        @input="$emit('input', $event)"
        :defaultTitle="$t('blog.add_category')"
        :heightClass="`ppv2-max-h-[85vh]`"
        height="auto"
        width="500px"
        centerContent
    >
        <template #content>
            <div class="ppv2-flex ppv2-flex-col ppv2-p-4" :style="{ gap: normalizeSize(16, true) }">
                <CustomInput
                    v-model="form.name"
                    :label="$t('blog.category_name')"
                    :placeholder="$t('blog.category_name')"
                    required
                    :errorText="errors.name ? errors.name[0] : ''"
                    :customLabelStyle="`font-size: ${normalizeSize(15, true)}`"
                    customLabelClass="poppinsLight ppv2-text-black"
                />
            </div>
        </template>
        <template #actions>
            <BaseButton
                variant="primary"
                @click="save"
                :loading="submitting"
                :disabled="submitting"
                customClass="!ppv2-bg-[#7D2DBD] hover:!ppv2-bg-[#6b26a3] !ppv2-min-w-[120px]"
                :customHeight="48"
            >
                {{ $t('common.add') }}
            </BaseButton>
        </template>
    </CustomDialog>
</template>

<script>
import axios from 'axios'
import normalizeSize from '../../../../utils/normalizeSize'
import CustomDialog from '../../../Shared/CustomDialog.vue'
import CustomInput from '../../../Inputs/CustomInput.vue'
import BaseButton from '../../../Shared/BaseButton.vue'

export default {
    name: 'BlogCategoryModal',
    components: {
        CustomDialog,
        CustomInput,
        BaseButton,
    },
    props: {
        value: { type: Boolean, required: true },
        token: { type: String, required: true },
    },
    data() {
        return {
            submitting: false,
            form: {
                name: '',
            },
            errors: {},
        }
    },
    methods: {
        normalizeSize,
        async save() {
            this.submitting = true
            this.errors = {}
            try {
                const response = await axios.post('/api/v3/blog/store-category', this.form, {
                    headers: { Authorization: `Bearer ${this.token}` },
                })
                if (response.data.success) {
                    this.$toast.success(this.$t('blog.category_create_success'))
                    this.$emit('category-created', response.data.data)
                    this.close()
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
                if (error.response && error.response.status === 422) {
                    this.errors = error.response.data.errors
                }
            } finally {
                this.submitting = false
            }
        },
        close() {
            this.form.name = ''
            this.errors = {}
            this.$emit('input', false)
        },
    },
}
</script>
